import styled from 'styled-components'
import Select from 'react-select'

export const CloseIcon = styled.div`
  background-color: rgb(242, 243, 245);
  border-radius: 5px;
  color: rgb(5, 5, 5);
  font-family: inherit;
  font-size: 1.07692rem;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
  padding: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: white;
    background-color: rgb(39, 129, 186);
  }
  position: absolute;
  right: 15px;
  top: 15px;
`

export const Container = styled.div`
  max-width: 1416px;
  margin: 20px auto 20px;
  padding:  20px 20px;
`
export const Title = styled.div`
  font-size: 1.5rem;
  color: rgb(43, 43, 43);
  font-family: Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif;
  font-weight: bold;
`

export const AGButton = styled.button<{ type?: 'primary' | 'default' }>`
  background-color: ${(p) =>
    p.type === 'primary' ? 'rgb(39, 129, 186)' : 'rgb(242, 243, 245)'};
  border-radius: 5px;
  border-radius: 5px;
  color: ${(p) =>
    p.type === 'primary' ? 'rgb(255, 255, 255)' : 'rgb(5, 5, 5)'};
  font-size: 1.07692rem;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
  font-size: 0.8125rem;
  width: auto;
  min-width: 50px;
  padding: 2px 15px;
  &:hover,
  &:focus {
    background-color: rgb(218, 218, 218);
  }
  /* height:40px; */
`

export const AGButtonPrimary = styled.button<{ type?: 'primary' | 'default' }>`
  background-color: rgb(39, 129, 186);
  border-radius: 5px;
  border-radius: 5px;
  color: rgb(255, 255, 255);
  font-size: 1.07692rem;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
  font-size: 0.8125rem;
  width: auto;
  min-width: 50px;
  padding: 2px 15px;
  margin:  0;
  margin-right:4px;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: rgb(31, 103, 149);
  }
`
export const AGButtonPrimarySearch = styled(AGButtonPrimary)`
  height: 40px;
  margin: 0;
  min-width: 120px;
  margin-left: 15px;
  @media (max-width: 1300px) {
    margin-top: 20px;
    margin-left: 0;
  }
  margin-top: 40px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
export const AGButtonSearch = styled(AGButton)`
  height: 40px;
  margin: 0;
`
export const TagLine = styled.div`
  color: rgb(5, 5, 5);
  font-size: 1.07692rem;
  font-weight: bold;
  line-height: 1.30769rem;
  display: flex;
  margin: 4px 8px 4px 0px;
  background-color: rgb(255, 255, 255);
  color: rgb(5, 5, 5);
  border-color: rgb(206, 206, 206);
  font-size: 0.625rem;
  padding: 5px 8px 3px;
  min-height: 24px;
  -webkit-box-align: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid rgb(206, 206, 206);
  display: block;
  -webkit-box-pack: center;
  justify-content: center;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: break-spaces;
  word-break: break-word;
  width: fit-content;
  cursor: auto;
  pointer-events: none;
`
export const InputLabel = styled.div`
  color: rgb(5, 5, 5);
  font-weight: bold;
  font-size: 0.875rem;
  margin: 10px 0;
`

export const AGSelect = styled(Select)`
  min-height: 40px;
  width: 100%;
  font-size: 0.875rem;
  cursor: pointer;
  @media (max-width: 768px) {
    padding-left: 0;
  }
`

export const AGSearch = styled.input`
  width: auto;
  border: 1px solid rgb(115, 115, 115) !important;
  border-radius: 4px;
  height: 38px;
  font-size: 0.875rem;
  width: 100%;
  padding-left: 10px;

  &:focus,
  &:hover {
    outline: none;
    border: 0.5px solid rgb(39, 129, 186) !important;
  }
`


export const CardTitle = styled.div`
  font-size: 1.125rem;
  color: rgb(43, 43, 43);
  font-family: Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
  height: 54px;
  line-height: 19px;
`
export const Result = styled(CardTitle)`
  height: auto;
  margin: 20px 0 20px;
`

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    display: block;
  }
  width:100%;
`


export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  background:white;
  padding:16px 16px 30px 16px;
`

export const InputContainer = styled.div`
  width: 44.5%;
  @media (max-width: 1300px) {
    width: 100%;
  }
`
export const InputSearch = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 8px;
    width: 16px;
    height: 16px;
    top: 12px;
  }
  ${AGSearch} {
    position: relative;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
`

export const Tab = styled.div`
 /* border:1px solid #d3d3d3; */
 width:auto;
 padding:4px 0;
 margin : 0 10px;
 cursor:pointer;
 &:hover, &.active {
  border-bottom: 2px solid rgb(39, 129, 186);
  color:rgb(39, 129, 186);
 }
`